import {createAction, props} from '@ngrx/store';


export const logout = createAction('[APP] logout');
export const messageDisplayed = createAction('[Message Display Component] message was displayed');
export const showMessage = createAction('[APP] show message', props<{message: string}>());

